import { render, staticRenderFns } from "./EditAppointmentDate.vue?vue&type=template&id=39275f5a&"
import script from "./EditAppointmentDate.vue?vue&type=script&lang=js&"
export * from "./EditAppointmentDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports